import { Component, Input } from '@angular/core';

import { IPaperProjectData } from 'editing-tool/src/app/shared/components/paper/steps/project/paper-project/paper-project-data.model';

@Component({
    selector: 'et-paper-project',
    templateUrl: './paper-project.component.html',
    styleUrls: ['./paper-project.component.scss'],
    standalone: false
})
export class PaperProjectComponent {

    @Input()
    public projectData: IPaperProjectData;

    @Input()
    public selected: boolean;

    @Input()
    public isReadonly: boolean;

    public selectProject(): void {

        if (!this.isReadonly && !this.projectData.project.authorPeriodExpired && !this.projectData.project.uploadLimitAchieved) {
            this.projectData.onSelectProjectAction(this.projectData.project.titleId, this.projectData.project.name);
        }
    }
}
